export const MY_LEVEL_AND_COURSE_HEADER = {
  displayName: "search_filter_my_level_label",
  id: 0, // header
};
export const FOLLOWED_LEVEL_AND_COURSE_HEADER = {
  displayName: "search_filter_followed_level_label",
  id: 0, // header
};
export const OTHER_LEVEL_AND_COURSE_HEADER = {
  displayName: "search_filter_other_level_label",
  id: 0, // header
};

export const MY_SUBJECTS_HEADER = {
  subjectName: "search_filter_my_subject_label",
  subjectId: 0, // header
};
export const FOLLOWED_SUBJECTS_HEADER = {
  subjectName: "search_filter_followed_subject_label",
  subjectId: 0, // header
};
export const OTHER_SUBJECTS_HEADER = {
  subjectName: "search_filter_other_subject_label",
  subjectId: 0, // header
};
